export default "__VITE_ASSET__e5d3e4d4__"